import isObject from '@utils/isObject';
import { savedObjectTypes } from '@constants/index';

export const getSavedContentType = (entityType) => {
  if (entityType === savedObjectTypes.LESSON) return 'Lesson';
  if (entityType === savedObjectTypes.TEST) return 'Test';
  if (entityType === savedObjectTypes.QUESTION) return 'Question';
  if (entityType === savedObjectTypes.NOTES) return 'Notes';
  return '';
};

export const getSavedQuestionTitle = ({
  question = {},
  hasComprehension,
  selectedLanguage
}) =>
  (hasComprehension &&
    (isObject(question.comprehension)
      ? question.comprehension[selectedLanguage]
      : question.comprehension)) ||
  (!hasComprehension &&
    (isObject(question.content)
      ? question.content[selectedLanguage]
      : question.content)) ||
  '';
